"use client";
import React from 'react';
import { Link } from 'react-router-dom';
import { useState } from "react";
import MobileLogo from '../../..//assets/images/resources/logo-1.png'

const MobileMenu = ({ isSidebar, handleMobileMenu, handleSidebar }) => {
  const [isActive, setIsActive] = useState({
    status: false,
    key: "",
    subMenuKey: "",
  });

  const handleToggle = (key, subMenuKey = "") => {
    if (isActive.key === key && isActive.subMenuKey === subMenuKey) {
      setIsActive({
        status: false,
        key: "",
        subMenuKey: "",
      });
    } else {
      setIsActive({
        status: true,
        key,
        subMenuKey,
      });
    }
  };
  return (
    <>
      {/*End Mobile Menu */}
      <div className="mobile-nav__wrapper">
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={handleMobileMenu}
        />
        {/* /.mobile-nav__overlay */}
        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={handleMobileMenu}
          >
            <i className="fa fa-times" />
          </span>
          <div className="logo-box">
            <Link to="/" aria-label="logo image">
            <img src={MobileLogo} alt="Logo" />
            </Link>
          </div>
          {/* /.logo-box */}
          <div className="mobile-nav__container">
          <ul className="main-menu__list">
  <li className={isActive.key === 1 ? "dropdown current" : "dropdown"}>
    <Link to="/" onClick={handleMobileMenu}>
      Home{" "}
    </Link>
   
  </li>

  <li className={isActive.key === 2 ? "dropdown current" : "dropdown"}>
    <Link to="/event" onClick={handleMobileMenu}>
      Event
    </Link>
    
  </li>

  <li className={isActive.key === 3 ? "dropdown current" : "dropdown"}>
    <Link to="/promo-codes" onClick={handleMobileMenu}>
       Promo Codes
    </Link>
   
  </li>

  <li className={isActive.key === 4 ? "dropdown current" : "dropdown"}>
    <Link to="/event-news" onClick={handleMobileMenu}>
      Event News
    </Link>
  </li>

  <li className={isActive.key === 5 ? "dropdown current" : "dropdown"}>
    <Link to="/about" onClick={handleMobileMenu}>
      About
    </Link>
    
   
  </li>

  <li>
    <Link to="/contact" onClick={handleMobileMenu}>
      Contact
    </Link>
  </li>
</ul>
          </div>
          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-envelope" />
              <a href="mailto:info@rsvppass.com">
                info@rsvppass.com
              </a>
            </li>
            <li>
              <i className="fa fa-phone-alt" />
              <a href="tel:+16195551234">+1 (619) 555-1234</a>
            </li>
          </ul>
          {/* /.mobile-nav__contact */}
        
          {/* /.mobile-nav__top */}
        </div>
        {/* /.mobile-nav__content */}
      </div>

      <div
        className="nav-overlay"
        style={{ display: `${isSidebar ? "block" : "none"}` }}
        onClick={handleSidebar}
      />
    </>
  );
};
export default MobileMenu;
